import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tab-menu-wrapper" }
const _hoisted_2 = { class: "tab-menu" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { href: "#" }

import { reactive } from 'vue';
import { ITabMenuProps } from './tab-menu.types';

type ITabMenuEmits = {
    (event: 'change', tabId: number): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'tab-menu',
  props: {
    props: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'change', tabId: number): void;
}), expose: any, slots: any, attrs: any }) {

const prop = __props as {
    props: ITabMenuProps;
};



const state = reactive<{ selectedTabId: number }>({
    selectedTabId: prop.props.selectedTabItemId,
});



function selectTab(tabId: number) {
    state.selectedTabId = tabId;
    emit('change', tabId);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.props.tabs, (tabItem) => {
        return (_openBlock(), _createElementBlock("li", {
          key: tabItem.id,
          class: _normalizeClass([
                    'tab-menu__item tab-item',
                    tabItem.id === state.selectedTabId
                        ? 'tab-item_selected'
                        : '',
                ]),
          onClick: ($event: any) => (selectTab(tabItem.id))
        }, [
          _createElementVNode("a", _hoisted_4, _toDisplayString(tabItem.title), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})